import React, {useContext, useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom"
import CampaignProgressBar, {CampaignProgress} from "./campaignProgressBar";
import PreviewCampaign from "./previewCampaign";
import CampaignTypeSelection from "./campaignTypeSelection";
import GroupSelection from "./groupSelection";
import DesignCampaign, {AppointmentReminderTemplateID} from "./designCampaign";
import {
    BeforeDayForAutomatedCampaign,
    CampaignSetting,
    getDefaultAppointmentReminderTemplates,
    getDefaultCampaignSetting,
    getDefaultDataForTemplateLanguage,
} from "./dataForDesignCampaign";
import {TemplateContent} from "./templateEditContentList";
import {SharedContext, SharedContextActionType} from "../sharedContextProvider";
import {ProviderContext} from "../providerContext";
import {ButtonStatus} from "../../components/button/enum";
import Button from "../../components/button/button";
import Alert from "../../components/modal/alert";
import {getCampaignList, getCampaignSettings} from "./campaignService";
import Spinner from "../../components/spinner/spinner";
import {AutomatedCampaignType, CampaignBigType, CampaignModel} from "./dataForActiveCampaign";
import {getCompliedMessageFromLibMessage, ReplaceableInfo} from "./templateEditor";
import {
    AppInstallationDefaultState,
    AppointmentReminderDefaultState,
    BirthdayDefaultState,
    EditorEmptyRawState,
} from "./templateEditorDefaultState";
import {differ} from "../../util/util";
import {ActionType} from "../../util/enum";
import {GetAppointmentHost} from "../../util/http/API";
import {CampaignListType} from "./campaign";
import {MaxAppointmentReminderCount, MaxBirthdayReminderCount} from "./campaignList";
import {PromptContext} from "../promptContext";
import moment from "moment/moment";

interface ILocation {
    campaignId: string,
    routePathHidden?: boolean
}

function NewCampaign() {
    const history = useHistory()
    const { sharedContextState, dispatchSharedContext } = useContext(SharedContext)
    const provider = useContext(ProviderContext)
    const [progress, setProgress] = useState<CampaignProgress>(CampaignProgress.campaignBigType)
    const [setting, setSetting] = useState<CampaignSetting>(getDefaultCampaignSetting(provider.officeLocations.length ? provider.officeLocations[0].olid : -1))
    const [dataForTemplateContent, setDataForTemplateContent] = useState<Array<TemplateContent>>(getDefaultDataForTemplateLanguage())
    const [showUnSavedChangeAlert, setShowUnSavedChangeAlert] = useState<boolean>(false)
    const [showFollowUpAlert, setShowFollowUpAlert] = useState<boolean>(false)
    const [isShowSpinner, setIsShowSpinner] = useState<boolean>(false)
    const [existingCampaignList, setExistingCampaignList] = useState<Array<CampaignModel>>([])
    const [reset, setReset] = useState<boolean>(false)

    const {showError} = useContext(PromptContext)

    const { search, state } = useLocation<ILocation>()
    const query = (new URLSearchParams(search))
    const campaignId = query.get("campaignId")
    let actionType: ActionType = ActionType.new
    if (query.get("actionType")) {
        actionType = query.get("actionType") as ActionType
    }

    const campaignType = query.get("type")

    const replaceableInfo: ReplaceableInfo = {}
    if (provider) {
        // if (provider.doctorPublicURL) {
        //     replaceableInfo.doctorPublicUrl = ` ${provider.doctorPublicURL}/******** `
        //     const subs = provider.doctorPublicURL.split("/#/")
        //     if (subs.length) {
        //         replaceableInfo.appointmentUrl = ` ${subs[0]}/#/wac/********** `
        //     }
        // } else {
        //     replaceableInfo.appointmentUrl = ` ${GetAppointmentHost()}/#/wac/********** `
        // }

        replaceableInfo.doctorPublicUrl = ` ${GetAppointmentHost()}/${provider.clinicID}/********** `
        replaceableInfo.appointmentUrl = ` ${GetAppointmentHost()}/wac/********** `
        replaceableInfo.practiceName = provider.clinicName

        // Information below will be replaced at backend for accuracy. by zhao dong at 05/11/2022
        // replaceableInfo.providerName = `Dr. ${provider.employeeFirstName} ${provider.employeeLastName}`
        //
        // const officeLocation = provider.officeLocations?.find((_office) => _office.olid === setting.olid)
        // replaceableInfo.practiceName = officeLocation?.clinicName
        // replaceableInfo.officePhone = officeLocation?.phone
    }

    useEffect(() => {
        if (actionType === ActionType.new && progress === CampaignProgress.campaignBigType) {
            setIsShowSpinner(true)
            getCampaignList(provider.mEmployeeID, CampaignListType.active, 1, 0, (list) => {
                setIsShowSpinner(false)
                setExistingCampaignList(list)
            }, (error) => {
                setIsShowSpinner(false)
                showError(error)
            })
        }
    }, [progress])

    useEffect(() => {
        if (reset) {
            setProgress(CampaignProgress.campaignBigType)
            setSetting(getDefaultCampaignSetting(provider.officeLocations.length ? provider.officeLocations[0].olid : -1))
        }
    }, [reset])

    useEffect(() => {
        if (reset) {
            onSelectCampaignType(CampaignBigType.automatedCampaign, AutomatedCampaignType.appointment)
        }
    }, [existingCampaignList])

    useEffect(() => {
        if (campaignId) {
            if (actionType === ActionType.edit) {
                setProgress(CampaignProgress.designCampaign)
            } else if (actionType === ActionType.view) {
                setProgress(CampaignProgress.summary)
            }

            setIsShowSpinner(true)
            getCampaignSettings(campaignId, (setting, templateContentList) => {
                setIsShowSpinner(false)
                setSetting(setting)
                setDataForTemplateContent(templateContentList)
            }, (error) => {
                setIsShowSpinner(false)
                showError(error)
            })
        }
        if (campaignType && parseInt(campaignType) >= 0) {
            onSelectCampaignType(CampaignBigType.automatedCampaign, parseInt(campaignType))
        }
    }, [])

    useEffect(() => {
        actionType !== ActionType.view && !sharedContextState.hasUnSavedChanges && dispatchSharedContext({type: SharedContextActionType.unsavedChange, state: true})
    }, [setting])

    useEffect(() => {
        let timer: any;
        if (progress === CampaignProgress.designCampaign) {
            const backupData = sessionStorage.getItem("backupDataTemplate")
            const backupDataTemplate = backupData ? JSON.parse(backupData) : undefined
            if (setting.campaignBigType === CampaignBigType.automatedCampaign) {
                if (setting.automatedCampaignType === AutomatedCampaignType.birthday) {
                    timer = differ(() => {
                        setDataForTemplateContent((pre) => backupDataTemplate || pre.map((item) => {
                            const _item = Object.assign({}, item)
                            _item.libMessage = BirthdayDefaultState(item.language)
                            _item.compliedMessage = getCompliedMessageFromLibMessage(_item.libMessage)
                            return _item
                        }))
                    }, 1000)
                } else if (setting.automatedCampaignType === AutomatedCampaignType.appointment) {
                    timer = differ(() => {
                        const template = getDefaultAppointmentReminderTemplates().find((item) => item.templateId === setting.templateId)
                        if (template) {
                            setDataForTemplateContent(backupDataTemplate || template.templateContent)
                        } else {
                            setDataForTemplateContent((pre) => backupDataTemplate || pre.map((item) => {
                                const _item = Object.assign({}, item)
                                _item.libMessage = AppointmentReminderDefaultState(item.language)
                                _item.compliedMessage = getCompliedMessageFromLibMessage(_item.libMessage)
                                return _item
                            }))
                        }
                    }, 1000)
                } else if (setting.automatedCampaignType === AutomatedCampaignType.appInstallation) {
                    timer = differ(() => {
                        setDataForTemplateContent((pre) => backupDataTemplate || pre.map((item) => {
                            const _item = Object.assign({}, item)
                            _item.libMessage = AppInstallationDefaultState(item.language)
                            _item.compliedMessage = getCompliedMessageFromLibMessage(_item.libMessage)
                            return _item
                        }))
                    }, 1000)
                } else {
                    timer = differ(() => {
                        setDataForTemplateContent((pre) => backupDataTemplate || pre.slice())
                    }, 1000)
                }
            } else {
                timer = differ(() => {
                    setDataForTemplateContent((pre) => backupDataTemplate || pre.slice())
                }, 1000)
            }
        }
        return () => {
            timer && clearTimeout(timer)
        }
    }, [progress])

    const onClose = () => {
        history.goBack()
        sharedContextState.hasUnSavedChanges && dispatchSharedContext({type: SharedContextActionType.unsavedChange, state: false})
    }

    let largeTitle = "New Campaign"
    if (actionType === ActionType.edit) {
        largeTitle = "Edit Campaign"
    } else if (actionType === ActionType.view) {
        largeTitle = "View Details"
    }

    const $pathHeader = (<div className={"flex flex-row items-center"}>
        <button onClick={() => {
            if (sharedContextState.hasUnSavedChanges) {
                setShowUnSavedChangeAlert(true)
            } else {
                onClose()
            }
        }} type={"button"} className={"text-sm text-gray-2 border-b border-gray-400 hover:text-theme-blue hover:border-theme-blue"}>Campaign</button>
        <p className={"text-sm text-gray-2 mx-2"}>{">"}</p>
        <p className={"text-sm text-gray-2"}>{largeTitle}</p>
    </div>)
    const $largeTitle = (<p className={"text-2xl text-gray-1 font-bold mt-4"}>{largeTitle}</p>)

    const $cancelBtn = (
        <Button status={ButtonStatus.light} onClick={() => {
            if (actionType !== ActionType.view && sharedContextState.hasUnSavedChanges) {
                setShowUnSavedChangeAlert(true)
            } else {
                onClose()
            }
        }}>
            {actionType === ActionType.view ? "Back" : "Cancel"}
        </Button>
    )

    const $header = (
        <div className={"w-full flex flex-row justify-between items-center"}>
            <div className={"w-full flex flex-col"}>
                {state?.routePathHidden ? null : $pathHeader}
                {$largeTitle}
            </div>
            {$cancelBtn}
        </div>
    )

    const onSelectCampaignType = (bigType: CampaignBigType, automatedType: AutomatedCampaignType) => {
        let defaultCampaignName = setting.campaignBigType === bigType ? setting.campaignName : ""
        let defaultTemplateId = setting.campaignBigType === bigType ? setting.templateId : ""
        let defaultGroupId = setting.campaignBigType === bigType ? setting.groupId : ""
        let defaultSetting = getDefaultCampaignSetting(provider.officeLocations.length ? provider.officeLocations[0].olid : -1)
        let defaultStartDate = defaultSetting.startDate
        let defaultSendDateTime = defaultSetting.sendDateTime
        let defaultEndDate = defaultSetting.endDate
        let beforeDay = defaultSetting.beforeDay

        if (bigType === CampaignBigType.automatedCampaign) {
            if (automatedType === AutomatedCampaignType.birthday) {
                defaultCampaignName = "Happy Birthday"
                beforeDay = BeforeDayForAutomatedCampaign.day0
            } else if (automatedType === AutomatedCampaignType.appointment) {
                const appointmentReminderCampaigns = existingCampaignList.filter((item) => item.summary.automatedCampaignType === AutomatedCampaignType.appointment)
                const defaultAppointmentReminderTemplates = getDefaultAppointmentReminderTemplates()
                if (defaultAppointmentReminderTemplates.length > appointmentReminderCampaigns.length) {
                    defaultTemplateId = defaultAppointmentReminderTemplates[appointmentReminderCampaigns.length].templateId
                }
                if (defaultTemplateId === AppointmentReminderTemplateID.primary) {
                    defaultCampaignName = "Appointment Reminder - Primary"
                } else if (defaultTemplateId === AppointmentReminderTemplateID.followUpWithURL) {
                    defaultCampaignName = "Appointment Reminder - Follow up"
                } else if (defaultTemplateId === AppointmentReminderTemplateID.followUpWithoutURL) {
                    defaultCampaignName = "Appointment Reminder - Final"
                }
            } else if (automatedType === AutomatedCampaignType.postAppointment) {
                defaultCampaignName = "Post-appointment message"
            } else if (automatedType === AutomatedCampaignType.appInstallation) {
                defaultCampaignName = "App Installation"
            }
            defaultSendDateTime = "09:00"
        }

        setSetting({
            ...setting,
            campaignBigType: bigType,
            automatedCampaignType: automatedType,
            groupId: defaultGroupId,
            templateId: defaultTemplateId,
            campaignName: defaultCampaignName,
            sendDateTime: defaultSendDateTime,
            startDate: defaultStartDate,
            endDate: defaultEndDate,
            beforeDay: beforeDay,
        })

        setDataForTemplateContent(getDefaultDataForTemplateLanguage(EditorEmptyRawState))
        setProgress((automatedType === AutomatedCampaignType.appointment || automatedType === AutomatedCampaignType.postAppointment) ? CampaignProgress.designCampaign : CampaignProgress.group)

        sessionStorage.removeItem("backupDataTemplate")
        sessionStorage.removeItem("selected_group_id")
    }

    const resetEditorTemplate = () => {
        sessionStorage.setItem("backupDataTemplate", JSON.stringify(dataForTemplateContent.slice()))
        // 重置editor，目的是为了使editor mentions检测能够生效。(原来在editor里面延迟设置editorState的方法会带来其他问题，故废弃)
        setDataForTemplateContent(getDefaultDataForTemplateLanguage(EditorEmptyRawState))
    }

    const $progressBar = actionType !== ActionType.view ? (<div className={"w-full px-6 lg:px-20"}>
        <CampaignProgressBar campaignBigType={setting.campaignBigType} automatedCampaignType={setting.automatedCampaignType} progress={progress} disablePastProgress={actionType === ActionType.edit} />
    </div>) : null

    let disableAutoCampaignTypes: Array<AutomatedCampaignType> = []
    if (existingCampaignList.filter((model) => model.summary.automatedCampaignType === AutomatedCampaignType.appointment).length >= MaxAppointmentReminderCount) {
        disableAutoCampaignTypes.push(AutomatedCampaignType.appointment)
    }
    if (existingCampaignList.filter((model) => model.summary.automatedCampaignType === AutomatedCampaignType.birthday).length >= MaxBirthdayReminderCount) {
        disableAutoCampaignTypes.push(AutomatedCampaignType.birthday)
    }
    const $progressContentView = () => {
        switch (progress) {
        case CampaignProgress.campaignBigType:
            return (
                <CampaignTypeSelection
                    disableAutoCampaignTypes={disableAutoCampaignTypes}
                    onSelect={onSelectCampaignType}
                    onBack={() => {
                        onClose()
                    }}
                />
            )
        case CampaignProgress.group:
            return (
                <GroupSelection
                    setting={setting}
                    onContinue={(_setting) => {
                        setSetting(_setting)
                        setProgress(CampaignProgress.designCampaign)
                    }}
                    onBack={() => {
                        setProgress(CampaignProgress.campaignBigType)
                        setSetting({...setting, campaignBigType: CampaignBigType.regularCampaign, automatedCampaignType: AutomatedCampaignType.none})
                    }}
                />
            )
        case CampaignProgress.designCampaign:
            return (
                <DesignCampaign
                    setting={setting}
                    dataForTemplateContent={dataForTemplateContent}
                    replaceableInfo={replaceableInfo}
                    onContinue={(_setting, dataForTemplateContent) => {
                        if (_setting.campaignBigType === CampaignBigType.regularCampaign && _setting.recurringCampaign) {
                            const resetEndDate = moment(_setting.startDate).add(Math.ceil(_setting.matchingCount / _setting.messagePerDay), "day")
                                .toDate()
                            setSetting({
                                ..._setting,
                                endDate: resetEndDate,
                            })
                        } else {
                            setSetting(_setting)
                        }
                        setDataForTemplateContent(dataForTemplateContent)
                        setProgress(CampaignProgress.summary)
                    }}
                    onBack={() => {
                        if (actionType === ActionType.new) {
                            setProgress((setting.automatedCampaignType === AutomatedCampaignType.appointment || setting.automatedCampaignType === AutomatedCampaignType.postAppointment) ? CampaignProgress.campaignBigType : CampaignProgress.group)
                            if ((setting.automatedCampaignType === AutomatedCampaignType.appointment || setting.automatedCampaignType === AutomatedCampaignType.postAppointment)){
                                setSetting({...setting, campaignBigType: CampaignBigType.regularCampaign, automatedCampaignType: AutomatedCampaignType.none})
                            }
                            resetEditorTemplate()
                        } else if (actionType !== ActionType.view && sharedContextState.hasUnSavedChanges) {
                            setShowUnSavedChangeAlert(true)
                        } else {
                            onClose()
                        }
                    }}
                />
            )
        case CampaignProgress.summary:
            return (
                <PreviewCampaign
                    actionType={actionType}
                    setting={setting}
                    dataForTemplateLanguage={dataForTemplateContent}
                    replaceableInfo={replaceableInfo}
                    onBack={(progress) => {
                        setProgress(progress ? progress : CampaignProgress.designCampaign)
                        resetEditorTemplate()
                    }}
                    onFinish={() => {
                        if (actionType === ActionType.new && setting.automatedCampaignType === AutomatedCampaignType.appointment) {
                            const existingReminderList = existingCampaignList.filter((item) => item.summary.automatedCampaignType === AutomatedCampaignType.appointment)
                            if (existingReminderList.length + 1 < MaxAppointmentReminderCount) {
                                setShowFollowUpAlert(true)
                                setReset(false)
                            } else {
                                onClose()
                            }
                        } else {
                            onClose()
                        }
                    }}
                />
            )
        default:
        }
    }

    const $unSavedChangeAlert = (
        <Alert
            isOpen={showUnSavedChangeAlert}
            title={"Unsaved Changes"}
            description={"Are you sure you want to discard this draft? Any changes made in the draft will be lost."}
            rejectAction={{title: "Cancel", onClick: () => {
                setShowUnSavedChangeAlert(false)
            }}
            }
            resolveAction={{title: "Discard", onClick: () => {
                setShowUnSavedChangeAlert(false)
                onClose()
            }}
            }
        />
    )

    const $createFollowUpAlert = (
        <Alert
            isOpen={showFollowUpAlert}
            title={"Create a follow-up campaign"}
            description={"You can set up another appointment reminder campaign to create a reminder sequence if needed."}
            rejectAction={{title: "No", onClick: () => {
                setShowFollowUpAlert(false)
                onClose()
            }}
            }
            resolveAction={{title: "Yes, create another one", onClick: () => {
                setShowFollowUpAlert(false)
                setReset(true)
            }}
            }
        />
    )

    const $actionContentView = (
        <div className={"w-4/5 mt-12 rounded-md space-y-10"}>
            {$progressBar}
            {$progressContentView()}
        </div>
    )

    const $spinner = (<Spinner isOpen={isShowSpinner} />)
    return (
        <div className={"w-full my-6 px-10 flex flex-col items-center"}>
            {$header}
            {$actionContentView}
            {$unSavedChangeAlert}
            {$createFollowUpAlert}
            {$spinner}
        </div>
    )
}

export default NewCampaign
